import React from "react";
import { GridColumn, GridContainer, GridRow } from "arv-reactcomponents";
import { OrderConfirmation } from "npmlinks-constants";
import PropTypes from "prop-types";

const { ORDERCONFIRMPAGE } = OrderConfirmation;

const OrderStorePickUp = props => {
  const { storeDetails } = props;

  return (
    <GridContainer className="nw-orderconfirm-storepickup-block">
      <GridRow className="nw-orderconfirm-storepick-row nw-orderconfirm-deliverydetails">
        <GridColumn className="nwc-grid-col-sm-3 nwc-grid-col-xs-12 nw-orderconfirm-deltypedetails">
          <span className="nw-orderconfirm-deltype-title">
            {ORDERCONFIRMPAGE.ORDER_STORE_PICKUP.TITLE}
          </span>
          <p className="nw-orderconfirm-deltype-subtitle">
            {ORDERCONFIRMPAGE.ORDER_STORE_PICKUP.SUB_TITLE_TEXT_FIRST}
          </p>
          <p className="nw-orderconfirm-deltype-subtitle">
            {ORDERCONFIRMPAGE.ORDER_STORE_PICKUP.SUB_TITLE_TEXT_SECOND}
          </p>
        </GridColumn>
        <GridColumn className="nwc-grid-col-sm-4 nwc-grid-col-xs-12 nw-orderconfirm-storepickup-info-col">
          <address className="nw-orderconfirm-address">
            <div className="nw-orderconfirm-storepickup-fcname nw-orderconfirm-storepickup-span">
              {storeDetails.fcName}
            </div>
            <div className="nw-orderconfirm-storepickup-span">
              {storeDetails.streetName}
            </div>
            <span className="nw-orderconfirm-storepickup-span">
              {storeDetails.streetNo}
            </span>
            <div>
              <span className="nw-orderconfirm-storepickup-span">
                {storeDetails.city},
              </span>
              <span className="nw-orderconfirm-storepickup-span">
                {storeDetails.state}
              </span>
              {/* <span className="nw-orderconfirm-storepickup-span">
                - {storeDetails.pincode}
              </span> */}
            </div>
            <div className="nw-orderconfirm-storepickup-span nw-orderconfirm-storepickup-col-values-wrap">
              <i className="icomoon-mobile nw-orderconfirm-addressicons" />
              {storeDetails.contactNumber}
            </div>
            <div className="nw-orderconfirm-storepickup-span">
              <i className="icomoon-clock nw-orderconfirm-addressicons" />
              {storeDetails.timings}
            </div>
            {/* <span className="nw-orderconfirm-storepickup-span nw-orderconfirm-storepickup-col-values-wrap">
              <i className="icomoon-calendar" />
              {storeDetails.workingDays}
            </span> */}
          </address>
        </GridColumn>
      </GridRow>
    </GridContainer>
  );
};

OrderStorePickUp.propTypes = {
  storeDetails: PropTypes.object.isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: OrderStorePickUp,
  component: OrderStorePickUp,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/OrderConfirmComponents/OrderConsignmentsBlock/OrderStorePickUp/index.js